// extracted by mini-css-extract-plugin
export var autoExpand = "_1u-b";
export var container = "_1u-a";
export var containerWidth = "_1u-8";
export var disabled = "_1u-2";
export var error = "_1u-3";
export var fullWidth = "_1u-9";
export var highlightContainer = "_1u-5";
export var inputWrapper = "_1u-0";
export var small = "_1u-1";
export var textarea = "_1u-4";
export var validatedTextarea = "_1u-6";
export var visuallyHidden = "_1u-7";